import React, {useMemo} from "react";
import {useAuth} from "./AuthProvider";
import {useMutation} from "@tanstack/react-query";


let TalentContext = React.createContext(null);

const TalentProvider = ({children, criteria, talent, onUpdated, canFavorite = true,...props}) => {


    const {auth} = useAuth();
    /*
    |--------------------------------------------------------------------------
    | Handling Requests - Add/Remove Team to/from Shortlist/Archive
    |--------------------------------------------------------------------------
    */
    const runProjectTalentRequest = async(method, successKey) => {
        let updatedTalent = await talent?.[method]()

        if (!updatedTalent) {
            return false;
        }

        TB.sysAlert(successKey);

        await TB.wait(300);

        return onUpdated(updatedTalent)
    }
    const updateFavoritesMutation = useMutation(['updateFavoritesMutation'],
        ({method, successKey}) => runProjectTalentRequest(method, successKey)
    )


    const addToFavorites = async() => {
        return updateFavoritesMutation.mutate({method: 'addToFavorites', successKey:'byo.favorites_added'})
    }

    const removeFromFavorites = async() => {
        return updateFavoritesMutation.mutate({method: 'removeFromFavorites', successKey:'byo.favorites_removed'})
    }
    const overrideClientPreferredRateMutation = useMutation(
        ['overrideClientPreferredRate', talent?.id],
        (rate) => {
            return props.overrideClientPreferredRate ? props.overrideClientPreferredRate(rate) : talent?.overrideClientPreferredRate(rate)
        }, {
            onSuccess: async (result) => {
                console.log('onSuccess', result)

                await TB.wait(300);

                TB.toast("Talent Preferred Rate Set Successfully", {type:'success'})
                return onUpdated(result)

            },
            onError: error => {
                TB.showServerErrorToast()
            }
        });

    const matchingDisciplines = useMemo(() => {
        if(!talent?.matching?.disciplines?.disciplines || !criteria?.disciplines) {
            return [];
        }
        return talent?.matchedDisciplines(criteria.disciplines);
    }, [criteria?.disciplines, talent?.match]);


    let value = {
        talent,
        criteria,
        addToFavorites,
        overrideClientPreferredRate: (rate) => overrideClientPreferredRateMutation.mutateAsync(rate),
        isDisabled: updateFavoritesMutation.isLoading || overrideClientPreferredRateMutation?.isLoading,
        canFavorite,
        removeFromFavorites,
        matchingDisciplines,
    }

    return (
        <TalentContext.Provider value={value}>
            {children}
        </TalentContext.Provider>
    );
}

const useTalent = () => {
    return React.useContext(TalentContext);
}
export default TalentProvider;
export {
    useTalent,
    TalentContext
}